import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import {
    Box,
    Typography,
    TextField,
    Button,
    Stepper,
    Step,
    StepLabel,
    Paper,
    Grid,
    IconButton,
    InputAdornment,
    Card,
    Autocomplete,
    Divider,
    CardMedia,
    CardContent,
    Modal,
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    Checkbox,
    MenuItem,
    Select,
    TableCell,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableBody,
    Tooltip
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import AppBarComponent from '../../../component/appbar';
import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdEmail } from "react-icons/md";
import { FaSquarePhone } from "react-icons/fa6";
import Cookies from 'js-cookie'
import { CreateBookingVIP, GetBoatByName, getBookingByID, GetBookingDataByIdVersion, GetBookingVersionHistory, getCountTicketByDate, GetVersionbyBooking, UpdateBooking } from '../../../service/booking_service';
import { getProvince, getDistricts, getSubDistrict, getTimeSlotsActive, getTimeSlotSpecialDay, GetTimeSlotsByTime, Getcountry } from '../../../service/utinity_service';

import { format, parse } from 'date-fns';
import { AlertError, AlertLoading, AlertSuccess } from '../../../component/popupAlert';
import { v4 as uuidv4 } from 'uuid';
import { ChooseBoatTobooking, getBoatDataActive, } from '../../../service/boat_service';

import CloseIcon from '@mui/icons-material/Close';
import HistoryIcon from '@mui/icons-material/History';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import VisibilityIcon from '@mui/icons-material/Visibility';

const TicketForm_View = () => {

    const theme = useTheme();
    const navigate = useNavigate()
    const { id, ver } = useParams();

    const [activeStep, setActiveStep] = useState(0);
    const location = useLocation();
    const pathname = location.pathname;
    const [modalOpen, setModalOpen] = useState(false);
    const [editMode, setEditMode] = useState(true);
    const [noteChange, setNoteChange] = useState("");
    const [tempdata, setTempData] = useState([]);
    const [timeSlotModalOpen, setTimeSlotModalOpen] = useState(false);
    const [updatedTimeSlots, setUpdatedTimeSlots] = useState([]);
    const [createState, setCreateState] = useState(false);
    const [versionState, setVersionState] = useState(false);
    const DefaultDate = new Date();
    DefaultDate.setDate(DefaultDate.getDate() + 1);
    const [selectedDate, setSelectedDate] = useState(DefaultDate);
    const [version, setVersion] = useState([]);
    const [openHistory, setOpenHistory] = useState(false);

    const defaultBookingData = {
        first_name: "",
        last_name: "",
        address: "",
        subdistrict: "",
        district: "",
        province: "",
        zip_code: "",
        email: "",
        tel: "",
        time: "",
        ticketDate: "",
        adults: "0",
        children: "0",
        total: "0",
        driverName: "",
        butlerName: "",
    }
    const [BookingData, setBookingData] = useState(defaultBookingData);

    const steps = ['รอชำระเงิน', 'ชำระเงินแล้ว', 'เลื่อน', 'รอให้บริการ', 'เสร็จสิ้น'];
    const token = Cookies.get('token');

    const [country, setCountry] = useState([]);
    const [province, setProvince] = useState([])
    const [district, setDistrict] = useState([])
    const [subdistrict, setSubdistrict] = useState([])
    const [districtDefaut, setDistrictDefaut] = useState([])
    const [subdistrictDefaut, setSubdistrictDefaut] = useState([])
    const [zip_code, setZipCode] = useState([])
    const [autocompleteState, setAutocomplateState] = useState({
        district: false, subDistrict: false, zip_code: false
    }) //

    const [loadingBoat, setLoadingBoat] = useState(true)

    const [boatData, setBoatData] = useState([]);
    const [selectedBoat, setSelectedBoat] = useState(null);

    const [backupdataTimeSlot, setBackupDataTimeSlot] = useState();

    const [selectedSlot, setSelectedSlot] = useState(null);
    const [availableSlots, setAvailableSlots] = useState(0)

    const [dataFetched, setDataFetched] = useState(false)

    const [loading, setLoading] = useState(true)
    const [isThai, setIsThai] = useState(true);

    const [backupversion, setBackupVersion] = useState(0);

    const [dataHistory, setDataHistory] = useState({})


    useEffect(() => {
        if (!token) {
            navigate('/login');
            return;
        }

        if (!dataFetched) {
            init()
            setDataFetched(true);
        }

        if (pathname.includes('/create')) {
            setCreateState(true);
            setEditMode(false);
        }

        else if (pathname.includes('/version')) {
            console.log('version', id, ver)
            setVersionState(true);
            setEditMode(true);
            handleGetBookingDataByIdVer(id, ver);
        } else {
            handleGetBookingById()
        }

        // handleGetEmtpyBoat()
    }, []);

    const init = async () => {
        try {

            const res = await Getcountry()
            setCountry(res)

            const responseProvince = await getProvince();
            setProvince(responseProvince);

            let responseAmphur = await getDistricts();
            // console.log("BookingData.province : ", BookingData.province)
            setDistrictDefaut(responseAmphur);
            setDistrict(responseAmphur);
            const responseSubDistrict = await getSubDistrict();
            setSubdistrictDefaut(responseSubDistrict);
            setSubdistrict(responseSubDistrict);  // Set zip code based on the current subdistrict
            // ดึงค่า zip_code ทั้งหมด
            const zipCodes = responseSubDistrict.map(subDistrict => subDistrict);

            setZipCode(zipCodes);
            handleGetBoatData();
        } catch (error) {
            console.error("Error during initialization:", error);
        }
    };

    const handleEditMode = async () => {
        setEditMode(!editMode);
        if (editMode === false) {
            setBookingData(tempdata);
            setTempData([])
        } else {
            setTempData(BookingData);
        }
    };

    const handleEditModeTime = async () => {
        setSelectedSlot(BookingData.time)
        // if (editMode === false) {
        //     setBookingData(tempdata);
        //     setTempData([])
        // } else {
        //     setTempData(BookingData);
        // }
        setBackupDataTimeSlot(BookingData.date);
        await handleGetEmtpyBoat(BookingData.date)

        setTimeSlotModalOpen(true);
    }

    const handleToggle = (slotTime, availableSlots) => () => {
        // console.log('Toggle', slotTime)
        // console.log('Toggle', availableSlots)
        setSelectedSlot(slotTime === selectedSlot ? null : slotTime);
        setAvailableSlots(availableSlots)
    };

    const handleSave = async () => {
        if (!createState) {
            handleChangeBoatDateTime();
        } else {
            handleChangeCreatBoatDateTime()
        }
    };

    const handleChangeCreatBoatDateTime = () => {
        // console.log('data:', BookingData);
        const data = { ...BookingData };
        data.time = selectedSlot;
        data.noteChange = noteChange;
        setBookingData(data);
        setTimeSlotModalOpen(false);
    }


    const handleChangeBoatDateTime = async () => {
        try {
            if (selectedSlot) {
                setTimeSlotModalOpen(false);
                setAvailableSlots(0)
                // console.log('Save', selectedSlot);
                const data = BookingData
                data.time = selectedSlot
                data.status = "เลื่อน"
                data.noteChange = noteChange
                data.version = backupversion
                setNoteChange("")
                // console.log('Save', data.boatname);
                const check = await GetBoatByName(BookingData, token)
                // console.log('Check', check)
                // console.log('Check', BookingData)
                // console.log('Check', availableSlots)
                if (availableSlots => (check.total_people + BookingData.total_people)) {
                    console.log('Check')
                    handleSubmit(data, "เลื่อนรอบ");
                } else {
                    AlertError('จำนวนที่นั่งในเรือไม่เพียงพอ');
                }
                window.location.reload();
            }
        } catch (error) {
            console.error("Error during save:", error);
            AlertError('เกิดข้อผิดพลาดในการบันทึก');
        }
    }

    const handleCloseModal = () => {
        setModalOpen(false);
    }

    const handleBoatSelect = (boat) => {
        setSelectedBoat(boat);
    }

    const handleSaveBoatSelection = async () => {
        //console.log("Save selected", BookingData);
        if (!selectedBoat) {
            // If no boat is selected, alert the user and return early
            AlertError('กรุณาเลือกเรือ');
            return;
        }

        // Show loading alert while the operation is in progress
        AlertLoading()
        if (!createState) {
            handleSelectBoat()
        } else {
            handleCreateSelectBoat()
        }
        // Clean up after the operation (e.g., close modal)
        handleCloseModal();
    };

    const handleCreateSelectBoat = async () => {
        // console.log("Create selected", BookingData);
        const data = BookingData
        data.boat_id = selectedBoat.boat_id
        data.boatName = selectedBoat.name
        // console.log("Create selected", data);
        AlertSuccess("สำเร็จ", "แก้ไขข้อมูลสำเร็จ");
    }

    const handleSelectBoat = async () => {
        // Show loading alert while the operation is in progress
        AlertLoading()
        try {
            // Make API call to update the booking with the selected boat
            const data = BookingData
            data.boat_id = selectedBoat.boat_id
            data.boatName = selectedBoat.name
            data.version = backupversion
            data.action_update = "เลือกเรือ"
            const res = await ChooseBoatTobooking(
                data,
                token
            );
            const response = await getBookingByID({ id: id, token: token })
            setIsThai(response.data.country == 764)
            setBookingData(response.data);
            const currentStepIndex = steps.findIndex(step => step === response.data.status);
            setActiveStep(currentStepIndex);
            const dateString = response.data.date;  // '20-11-2024'

            // Split the date string into day, month, and year
            const [day, month, year] = dateString.split('-');

            // Create a new Date object in 'yyyy-mm-dd' format, which is valid for JavaScript
            const formattedDate = `${year}-${month}-${day}`;
            const bookingDate = new Date(formattedDate);
            setSelectedDate(bookingDate);
            // console.log("data update : ", data)
            // If successful, show a success alert
            AlertSuccess("สำเร็จ", "แก้ไขข้อมูลสำเร็จ");
            window.location.reload();

        } catch (error) {
            // Handle error: show error message if the request fails
            console.error(error);
            AlertError('ไม่สามารถแก้ไขการจองได้', error.message);
        }
    }


    const handleGetBookingById = async () => {
        // console.log(id)
        setLoading(true);
        try {
            const response = await getBookingByID({ id: id, token: token })
            setIsThai(response.data.country == 764)
            setBookingData(response.data);
            setBackupVersion(response.data.version)
            const currentStepIndex = steps.findIndex(step => step === response.data.status);
            setActiveStep(currentStepIndex);
            const dateString = response.data.date;  // '20-11-2024'

            // Split the date string into day, month, and year
            const [day, month, year] = dateString.split('-');

            // Create a new Date object in 'yyyy-mm-dd' format, which is valid for JavaScript
            const formattedDate = `${year}-${month}-${day}`;
            const bookingDate = new Date(formattedDate);
            setSelectedDate(bookingDate);
            const res = await GetVersionbyBooking(id);
            setVersion(res)
            setLoading(false);
        } catch (error) {
            navigate('/404')
        }
    }

    const handleChange = (event) => {
        const { name, value } = event.target;

        // Log the current name and value
        // console.log(`Changing field: ${name}, New value: ${value}`);

        // Update the booking data state
        setBookingData(prevState => {
            const updatedBookingData = {
                ...prevState,
                [name]: value,
                ...(name === 'time' && { status: "เลื่อน" }) // If the name is 'time', set status to "เลื่อน"
            };

            // Log the updated booking data
            // console.log("Updated booking data:", updatedBookingData);

            return updatedBookingData;
        });
    };

    const handleSeletVersion = (event) => {
        const { name, value } = event.target;
        handleGetBookingDataByIdVer(id, value)
    };

    const handleGetBookingDataByIdVer = async (id, ver) => {
        setLoading(true);
        try {
            const res = await GetBookingDataByIdVersion(id, ver);
            res.boatName = res.boatname
            console.log(res)
            const currentStepIndex = steps.findIndex(step => step === res.status);
            setActiveStep(currentStepIndex);
            setBookingData(res);
        } catch (error) {
            console.error("handleGetBookingDataByIdVer", error.message);
            AlertError('เกิดข้อผิดพลาด', 'ไม่สามารถดึงข้อมูลการจองได้');
        }
        setLoading(false);
    }

    useEffect(() => {
        setBookingData(prevState => ({
            ...prevState,
            total_people: parseInt(prevState.adults || 0, 10) + parseInt(prevState.children || 0, 10)
        }));
    }, [BookingData.adults, BookingData.children]);

    const handleChangeAutocomplate = async (event, newValue, name) => {
        // console.log("newvalue", newValue);

        if (name === "country") {
            if (newValue) {
                const updatedData = { ...BookingData };
                updatedData.zip_code = "";
                updatedData.province = "";
                updatedData.address_details = "";
                updatedData.subdistrict = "";
                updatedData.district = "";
                updatedData[name] = newValue.value;
                setBookingData(updatedData);
                setIsThai(newValue.value == 764)
            } else {
                const updatedData = { ...BookingData };
                updatedData[name] = "";
                setBookingData(updatedData);
            }
            // console.log('updateData : ',updatedData)      
            return;
        }

        if (newValue) {
            setBookingData(prevData => {
                const newData = { ...prevData };
                if (name === 'zip_code') {
                    newData[name] = newValue.zip_code;
                } else if (name === 'subdistrict') {
                    newData[name] = newValue.value;
                    newData["zip_code"] = ""
                    const currentSubdistricts = subdistrictDefaut.filter(d => newValue.value === d.value);
                    setZipCode(currentSubdistricts);  // Set zip code based on the current subdistrict
                    setAutocomplateState({ province: true, district: true, subDistrict: true, zip_code: true });
                } else if (name === "province") {
                    newData[name] = newValue.value;
                    newData["district"] = null
                    newData["subdistrict"] = null
                    newData["zip_code"] = null
                    setDistrict(districtDefaut.filter(d => newValue.value === d.province_id));
                    setAutocomplateState({
                        province: true,
                        district: true,
                        subdistrict: false,
                        zip_code: false
                    });
                } else if (name === "district") {
                    newData[name] = newValue.value;
                    newData["subdistrict"] = null
                    newData["zip_code"] = null
                    setSubdistrict(subdistrictDefaut.filter(d => newValue.value === d.district_id));
                    setAutocomplateState({ province: true, district: true, subDistrict: true, zip_code: false });
                }
                return newData;
            });
        } else {
            setBookingData(prevData => {
                const newData = { ...prevData };
                if (name === 'zip_code') {
                    newData[name] = "";
                } else if (name === 'subdistrict') {
                    newData[name] = "";
                    newData["zip_code"] = ""
                    setAutocomplateState({ province: true, district: true, subDistrict: true, zip_code: false });
                } else if (name === "province") {
                    newData[name] = "";
                    newData["district"] = null
                    newData["subdistrict"] = null
                    newData["zip_code"] = null
                    setAutocomplateState({
                        province: true,
                        district: false,
                        subdistrict: false,
                        zip_code: false
                    });
                } else if (name === "district") {
                    newData[name] = "";
                    newData["subdistrict"] = null
                    newData["zip_code"] = null

                    setAutocomplateState({ province: true, district: true, subDistrict: false, zip_code: false });
                }
                return newData;
            });
        }
        // console.log("test result", BookingData);
    };

    const handleChangeStatus = async (status) => {
        const data = BookingData
        data.action_update = 'อัพเดทสถาณะการจ่ายเงิน'
        data.status = status
        try {
            const res = await UpdateBooking(data, token);
            AlertSuccess('อัพเดทข้อมูลสำเร็จ');
            const resById = handleGetBookingById()
            setBookingData(resById);
        } catch (error) {
            AlertError('เกิดข้อผิดพลาด')
        }
    }

    const handleSubmit = async (data, update) => {
        // If editing existing booking
        if (!createState) {
            AlertLoading();
            setEditMode(true);
            setAutocomplateState({ district: false, subDistrict: false, zip_code: false });
            try {
                // BookingData.id = uuidv4();
                // console.log("data", data)
                data.version = backupversion
                data.action_update = update
                // console.log("data", data)
                const res = await UpdateBooking(data, token);
                AlertSuccess('อัพเดทข้อมูลสำเร็จ');
            } catch (err) {
                AlertError('การแก้ไขผิดพลาด');
            }
            setTempData([]);
            window.location.reload();
            return;
        } else {
            if (BookingData.time) {
                // console.log("Booking Data:", BookingData);

                // Validate passenger counts
                if (data.adults < 0 || data.children < 0) {
                    AlertError('ไม่สามารถทำการจองได้', 'จำนวนโดยสารไม่ถูกต้อง');
                    return;
                }

                if (data.children > 0 && data.adults <= 0) {
                    AlertError('ไม่สามารถทำการจองได้', 'จำนวนผู้โดยสาร "ผู้ใหญ่" น้อยเกินไป');
                    return;
                }

                if (data.total_people === 0) {
                    AlertError('ไม่สามารถทำการจองได้', 'จำนวนผู้โดยสารน้อยเกินไป');
                    return;
                }

                try {
                    // Fetch price details based on selected time
                    const res = await GetTimeSlotsByTime(BookingData.time, token);
                    const bookingDetails = { ...BookingData, id: uuidv4() };
                    const priceAdult = res.price_adult * data.adults;
                    const priceChild = res.price_children * data.children;
                    bookingDetails.total_price = priceAdult + priceChild;
                    bookingDetails.isVIP = true;

                    // console.log("Booking Details:", bookingDetails);

                    // Attempt to create VIP booking
                    const createRes = await CreateBookingVIP(bookingDetails, token);
                    AlertSuccess('เพิ่มรายการจองสำเร็จ');
                    navigate('/thewonderblueadmin_admin')
                } catch (error) {
                    console.error("Booking creation error:", error.message);
                    AlertError('เกิดข้อผิดพลาด', 'กรุณาลองใหม่อีกครั้ง');
                }

            } else {
                AlertError('เกิดข้อผิดพลาด', 'กรุณาเลือกช่วงเวลาก่อนบันทึก');
            }
        }
    };

    const handleToggleCondition = (event) => {
        const { name } = event.target; // ดึง name จาก checkbox
        setBookingData((prev) => ({
            ...prev,
            [name]: prev[name] === 1 ? 0 : 1, // สลับค่า 0 กับ 1
        }));
    };

    const handleGetBoatData = async () => {
        setLoadingBoat(true);
        try {
            const res = await getBoatDataActive();
            setBoatData(res);
        } catch (error) {
            AlertError('ไม่สามารถดึงข้อมูลเรือได้', error.message);
        }
        setLoadingBoat(false);
    }

    const formatDateForDisplay = (dateString) => {
        if (!dateString) return '';
        const date = parse(dateString, 'dd-MM-yyyy', new Date());
        return format(date, 'yyyy-MM-dd');
    };

    const formatDateForState = (dateString) => {
        if (!dateString) return '';
        const date = parse(dateString, 'yyyy-MM-dd', new Date());
        return format(date, 'dd-MM-yyyy');
    };

    const handleDateTimeChange = (event) => {
        const { name, value } = event.target;
        setBookingData(prevData => ({
            ...prevData,
            [name]: formatDateForState(value),
            ["status"]: "เลื่อน"
        }));
        // console.log('Setting: ', formatDateForState(value))
    };

    const handleDateTimeChangeTimeSlot = (e) => {
        const { name, value } = e.target;
        const data = new Date(value);
        setSelectedDate(data)
        setUpdatedTimeSlots([])
        setBookingData(prevData => ({
            ...prevData,
            [name]: formatDateForState(value),
            ["status"]: "เลื่อน"
        }));
        handleGetEmtpyBoat(formatDateForState(value))
    }


    const HistoryModal = ({ open, onClose, dataHistory = [] }) => {
        return (
            <Modal
                open={open}
                onClose={onClose}
                aria-labelledby="history-modal-title"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '90%',
                    maxWidth: '900px',
                    bgcolor: 'background.paper',
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 0,
                    outline: 'none',
                }}>
                    {/* Header Section */}
                    <Box sx={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        bgcolor: 'primary.main',
                        color: 'white',
                        p: 2,
                        borderTopLeftRadius: 8,
                        borderTopRightRadius: 8,
                    }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, m: 2 }}>
                            <HistoryIcon />
                            <Typography
                                id="history-modal-title"
                                variant="h6"
                                component="h2"
                                sx={{ fontWeight: 500 }}
                            >
                                ข้อมูลการดำเนินงาน
                            </Typography>
                        </Box>
                        <IconButton
                            onClick={onClose}
                            sx={{ color: 'white', m: 2 }}
                            size="small"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Box>

                    {/* Content Section */}
                    <Box sx={{ m: 3 }}>
                        <TableContainer
                            component={Paper}
                            elevation={0}
                            sx={{
                                maxHeight: 450,
                                mb: 2,
                                '& .MuiTableCell-root': {
                                    px: 3,
                                    py: 2,
                                    fontSize: '0.95rem',
                                },
                                '& .MuiTableHead-root': {
                                    bgcolor: 'primary.light',
                                    '& .MuiTableCell-root': {
                                        color: 'primary.dark',
                                        fontWeight: 600,
                                        whiteSpace: 'nowrap',
                                    }
                                },
                                border: 1,
                                borderColor: 'divider',
                                borderRadius: 1,
                            }}
                        >
                            <Table stickyHeader size="medium">
                                <TableHead>
                                    <TableRow>
                                        <TableCell sx={{ width: '10%' }}>ID</TableCell>
                                        <TableCell sx={{ width: '20%' }}>แก้ไขโดย</TableCell>
                                        <TableCell>การดำเนินงาน</TableCell>
                                        <TableCell sx={{ width: '20%' }}>เวลา</TableCell>
                                        <TableCell sx={{ width: '5%' }}>ตัวเลือก</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {Array.isArray(dataHistory) && dataHistory.map((row) => (
                                        <TableRow
                                            key={row.booking_id}
                                            hover
                                            sx={{
                                                '&:last-child td, &:last-child th': { border: 0 },
                                                '&:hover': {
                                                    bgcolor: 'primary.50',
                                                },
                                                transition: 'background-color 0.2s',
                                            }}
                                        >
                                            <TableCell>
                                                <Typography fontWeight={500}>
                                                    {row.booking_id}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>{row.update_by}</TableCell>
                                            <TableCell sx={{
                                                maxWidth: 400,
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis',
                                                whiteSpace: 'nowrap',
                                            }}>
                                                <Tooltip title={row.action_update} arrow>
                                                    <span>{row.action_update}</span>
                                                </Tooltip>
                                            </TableCell>
                                            <TableCell sx={{ color: 'text.secondary' }}>
                                                {new Date(row.create_date).toLocaleDateString('en-GB')}
                                            </TableCell>
                                            <TableCell align="center" sx={{ color: 'text.secondary' }}>
                                                <IconButton
                                                    onClick={() => window.open(window.location.origin + '/thewonderblueadmin_booking/version/' + row.version + '/id/' + id)}
                                                    sx={{
                                                        color: 'text.secondary',
                                                        '&:hover': {
                                                            color: 'primary.main', // Optional hover effect
                                                        },
                                                    }}
                                                >
                                                    <VisibilityIcon fontSize="small" />
                                                </IconButton>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>
            </Modal>
        );
    };

    const handleCloseModalTimnSlot = (e) => {

        if (setSelectedSlot.time) {
            setSelectedSlot(null)
            setUpdatedTimeSlots([])
            const { name, value } = e.target;
            setBookingData(prevData => ({
                ...prevData,
                ['date']: formatDateForState(value),
                ["status"]: "เลื่อน"
            }));
        } else {
            setBookingData(prevData => ({
                ...prevData,
                ['date']: backupdataTimeSlot,
            }));
            setBackupDataTimeSlot("")
            setUpdatedTimeSlots([])
        }
        setTimeSlotModalOpen(false)
    }

    const handleGetEmtpyBoat = async (date) => {
        try {
            const res = await getCountTicketByDate(date, token)
            let resTimeslot = await getTimeSlotSpecialDay(date);
            // console.log("Count:", resTimeslot);

            if (resTimeslot.length <= 0) {
                resTimeslot = await getTimeSlotsActive();
                // console.log("Time slots:", resTimeslot);
            }

            const updatedTimeSlots = resTimeslot.map((slot) => {
                // Improved matching logic
                const matchingData = res.find((item) => {
                    const [slotStart] = slot.time.split(' - ');
                    const [itemStart] = item.time.split(' - ');
                    return slotStart === itemStart;
                }) || {
                    total_adults: 0,
                    total_children: 0,
                    total_people: 0,
                    total: slot.total_people,
                };

                // console.log(`Matching for ${slot.time}:`, matchingData);

                return {
                    ...slot,
                    total_adults: matchingData.total_adults,
                    total_children: matchingData.total_children,
                    total_people: matchingData.total_people,
                    total: slot.total_people,
                };
            });
            // console.log(`updatedTimeSlots :`, updatedTimeSlots)
            setUpdatedTimeSlots(updatedTimeSlots)
        } catch (error) {
            AlertError('ไม่สามารถดึงข้อมูลเรือได้', error.message);
        }
    }

    const handleTimeSlotIsAble = (time) => {
        // console.log('Selected Date:', selectedDate);
        // console.log('Time:', time);

        // Split the time string into start and end times
        const [startTime, endTime] = time.split(' - ');

        // Extract hours and minutes from the start time
        const [hours, minutes] = startTime.split(":").map(Number);

        // Create a new date object for the selected date and start time
        const newDateTime = new Date(
            selectedDate.getFullYear(),
            selectedDate.getMonth(),
            selectedDate.getDate(),
            hours,
            minutes,
            0
        );

        // Get the current date and time
        const nowTime = new Date();

        // console.log("New Date:", newDateTime);
        // console.log("nowTime:", nowTime);

        // Check if the new date is at least 1 day after the current date
        return !(newDateTime.getTime() >= new Date(nowTime.getTime()).getTime())
    };

    const handleGetVersionHistory = async () => {
        try {
            const res = await GetBookingVersionHistory(id, token)
            console.log(res);
            setDataHistory(res);
            setOpenHistory(true);
        } catch (error) {
            AlertError('ไม่สามารถดึงข้อมูลประวัติการเปลี่ยนแปลงได้', error.message);
        }
    };


    const renderTimeSlotModal = () => (
        <Modal
            open={timeSlotModalOpen}
            onClose={handleCloseModalTimnSlot}
            aria-labelledby="time-slots-modal"
            aria-describedby="modal-to-display-time-slots"
        >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 600,
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 4,
                borderRadius: 2,
                maxHeight: '80vh',
                overflow: 'auto',
            }}>
                <Box sx={{ margin: 4 }}>
                    <Grid item xs={12} sm={4}>
                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Date (MM/DD/YYYY)</Typography>
                        <TextField
                            fullWidth
                            name="date"
                            label="Date and Time"
                            type="date"
                            value={formatDateForDisplay(BookingData.date)}
                            onChange={handleDateTimeChangeTimeSlot}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </Grid>
                    {BookingData.date && (
                        <Box>
                            <Typography variant="h6" component="h2" gutterBottom>
                                เลือกช่วงเวลาที่ว่าง
                            </Typography>
                            <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
                                {updatedTimeSlots.map((slot) => {
                                    const labelId = `checkbox-list-label-${slot.time}`;
                                    const availableSlots = slot.total - slot.total_people;

                                    return (
                                        <ListItem
                                            key={slot.time}
                                            dense
                                            button
                                            onClick={handleToggle(slot.time, availableSlots)}
                                            disabled={availableSlots <= 0 || handleTimeSlotIsAble(slot.time)}
                                        >
                                            <ListItemText
                                                id={labelId}
                                                primary={slot.time}
                                                secondary={`คนทั้งหมด: ${slot.total_people} คน, ที่ว่าง: ${availableSlots} คน`}
                                            />
                                            <ListItemSecondaryAction>
                                                <Checkbox
                                                    edge="end"
                                                    onChange={handleToggle(slot.time, availableSlots)}
                                                    checked={selectedSlot === slot.time}
                                                    inputProps={{ 'aria-labelledby': labelId }}
                                                    disabled={availableSlots <= 0 || handleTimeSlotIsAble(slot.time)}
                                                />
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    );
                                })}
                            </List>
                            <Box>
                                <Typography sx={{ margin: '12px' }}>หมายเหตุ</Typography>
                                <TextField
                                    fullWidth
                                    name="noteBoat"
                                    label="หมายเหตุ"
                                    value={noteChange}
                                    onChange={(e) => setNoteChange(e.target.value)}
                                    multiline
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                        </Box>
                    )}
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleCloseModalTimnSlot} variant="outlined" sx={{ mr: 1 }}>
                            ยกเลิก
                        </Button>
                        <Button onClick={(e) => handleSave(availableSlots)} variant="contained" disabled={!selectedSlot}>
                            บันทึก
                        </Button>
                    </Box>
                </Box>
            </Box>
        </Modal>
    )

    const BoatSelectionModal = () => {
        return (
            <Modal
                open={modalOpen}
                onClose={handleCloseModal}
                aria-labelledby="select-boat-modal"
                aria-describedby="modal-to-select-boat"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 1200,
                    height: 800,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    display: 'flex',
                }}>
                    {/* Left side - Boat selection */}
                    <Box sx={{ width: '50%', height: '100%', overflowY: 'auto', pr: 2, }}>
                        <Box sx={{ margin: 4 }}>
                            <Typography variant="h6" component="h2" gutterBottom>
                                {loadingBoat ? "กำลังโหลดข้อมูลเรือ..." : "เลือกเรือ"}
                            </Typography>
                            <Divider />
                            <Grid container spacing={2} sx={{ mt: 1 }}>
                                {boatData.map((boat) => (
                                    <Grid item xs={6} key={boat.id}>
                                        <Card
                                            onClick={() => handleBoatSelect(boat)}
                                            sx={{
                                                cursor: "pointer",
                                                border: selectedBoat?.id === boat.id
                                                    ? `2px solid ${theme.palette.primary.main}`
                                                    : "none",
                                                height: '100%',
                                                display: 'flex',
                                                flexDirection: 'column',
                                            }}
                                        >
                                            <CardMedia
                                                component="img"
                                                height="100"
                                                image={"data:image/png;base64," + boat.image}
                                                alt={boat.name}
                                                sx={{ objectFit: 'cover' }}
                                            />
                                            <CardContent sx={{ flexGrow: 1 }}>
                                                <Typography variant="body2" component="div">
                                                    {boat.name}
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        </Box>
                    </Box>

                    {/* Right side - Input fields */}
                    <Box sx={{ width: '50%', height: '100%', pl: 2 }}>
                        <Box sx={{ margin: 4 }}>
                            <Typography variant="h6" component="h2" gutterBottom>
                                ข้อมูลเพิ่มเติม
                            </Typography>
                            <Divider />
                            <Box sx={{ mt: 2 }}>
                                <Typography sx={{ mb: 1 }}>เลือกพนักงานขับ</Typography>
                                <TextField
                                    fullWidth
                                    name="driverName"
                                    label="พนักงานขับ"
                                    value={BookingData.driverName}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ mb: 2 }}
                                />
                                <Typography sx={{ mb: 1 }}>เลือกผู้ช่วย</Typography>
                                <TextField
                                    fullWidth
                                    name="butlerName"
                                    label="ผู้ช่วย"
                                    value={BookingData.butlerName}
                                    onChange={handleChange}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    sx={{ mb: 2 }}
                                />
                            </Box>
                            <Box>
                                <Typography sx={{ margin: '8px' }}>หมายเหตุ</Typography>
                                <TextField
                                    fullWidth
                                    name="noteBoat"
                                    label="หมายเหตุ"
                                    value={BookingData.noteBoat}
                                    onChange={handleChange}
                                    multiline
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                sx={{ mt: 3 }}
                                onClick={handleSaveBoatSelection}
                                disabled={!selectedBoat}
                            >
                                {loadingBoat ? "กำลังโหลด..." : "บันทึก"}
                            </Button>
                        </Box>
                    </Box>
                </Box>
            </Modal>
        );
    };

    return (
        <Box>
            <AppBarComponent />
            <Box sx={{ display: 'flex', height: 'auto', bgcolor: 'white', margin: 1 }}>
                <Paper
                    elevation={3}
                    sx={{
                        m: 'auto',
                        width: '90%',
                        maxWidth: 2000,
                        height: '90%',
                        p: 3,
                        borderRadius: 4,
                        display: 'flex',
                    }}
                >
                    <Box sx={{ width: '25%', borderRight: '1px solid #e0e0e0', pr: 2 }}>
                        <Typography variant="h6" sx={{ mb: 2, color: '#1976d2', fontWeight: 'bold' }}>
                            {createState ? "สร้างรายการจอง" : `Ticket number: ${BookingData.booking_id}`}
                            {!versionState && (<IconButton size="medium" sx={{ ml: 1 }} onClick={handleGetVersionHistory}>
                                <HistoryIcon />
                            </IconButton>)}
                        </Typography>

                        <Divider sx={{ marginRight: 3 }} />
                        {
                            !versionState && (
                                <Box>
                                    <Typography variant="body2" sx={{ mb: 1, fontWeight: 'bold', fontSize: '18px', marginTop: '8px' }}>
                                        Option
                                    </Typography>

                                    {!createState && (
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            sx={{
                                                mt: '12px',
                                                width: '96%',
                                                borderColor: editMode ? 'primary.main' : 'black',
                                                color: editMode ? 'primary.main' : 'black',
                                            }}
                                            onClick={handleEditMode}
                                        >
                                            {editMode === true ? "แก้ไขข้อมูลลูกค้า" : "ปิดการแก้ไข"}
                                        </Button>
                                    )}

                                    {/* <Button
                                fullWidth
                                variant="outlined"
                                sx={{ mt: '12px', width: '96%' }}
                                onClick={handleGetInvoicePDF}
                            >
                                Download ใบเสร็จรับเงิน
                            </Button> */}
                                    {
                                        BookingData.status !== "เสร็จสิ้น" && BookingData.status !== "ยกเลิก" && BookingData.status !== 'ชำระเงินไม่สำเร็จ' && BookingData.status !== 'รอชำระเงิน' && (
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{ mt: '12px', width: '96%' }}
                                                onClick={(e) => handleEditModeTime(e)}
                                            >
                                                {createState ? "เลือกรอบเรือ" : 'เลื่อนรอบเรือ'}
                                            </Button>
                                        )
                                    }
                                    {
                                        (BookingData.status !== 'ชำระเงินไม่สำเร็จ' && BookingData.status !== 'รอชำระเงิน') && (
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{ mt: '12px', width: '96%' }}
                                                onClick={() => setModalOpen(true)}
                                            >
                                                เลือกเรือ
                                            </Button>
                                        )
                                    }
                                    {(!createState && (BookingData.status === 'ชำระเงินไม่สำเร็จ' || BookingData.status === 'รอชำระเงิน')) && (
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            sx={{ mt: '12px', width: '96%' }}
                                            onClick={(e) => handleChangeStatus('รอให้บริการ')}
                                        >
                                            อัพเดทสถานะการชำระเงิน
                                        </Button>
                                    )}
                                    {!createState && BookingData.status === 'รอชำระเงิน' && (
                                        <Button
                                            fullWidth
                                            variant="outlined"
                                            sx={{ mt: '12px', width: '96%' }}
                                            onClick={(e) => handleChangeStatus('ยกเลิก')}
                                        >
                                            ยกเลิกการจอง
                                        </Button>
                                    )}
                                </Box>
                            )
                        }

                    </Box>
                    <Box sx={{ flexGrow: 1, width: '75%', overflowY: 'auto', maxHeight: 'calc(100vh - 100px)' }}>
                        {
                            versionState && (
                                <Card
                                    sx={{
                                        padding: 2,
                                        margin: 5,
                                        boxShadow: 4,
                                        borderRadius: 4,
                                        backgroundColor: 'warning.main' // ใช้สีจากธีม MUI
                                    }}
                                >
                                    <Box>
                                        <Typography sx={{ margin: '12px',color:'white' }}>
                                            ประวัติการแก้ไขข้อมูลโดย {BookingData.update_by} ในวันที่ {new Date(BookingData.create_date).toLocaleDateString('en-GB')}
                                        </Typography>
                                    </Box>
                                </Card>
                            )
                            
                        }
                        {!createState &&
                            <Box>
                                <Typography variant="h5" sx={{ mb: 2, margin: 5 }}>
                                    Status Ticket
                                </Typography>
                                {
                                    loading === false ? <Stepper activeStep={activeStep} alternativeLabel sx={{ mb: 4 }}>
                                    {steps.map((label, index) => (
                                        <Step key={label}>
                                            <StepLabel>{label}</StepLabel>
                                        </Step>

                                    ))}
                                </Stepper> : <Typography variant="h5" >loading</Typography>
                                }
                            </Box>
                        }
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                Ticket details
                                <IconButton size="small" >
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <Grid container spacing={2}>
                                {BookingData.date && (
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Date (MM/DD/YYYY)</Typography>
                                        <TextField
                                            fullWidth
                                            name="date"
                                            label="Date and Time"
                                            type="date"
                                            value={formatDateForDisplay(BookingData.date)}
                                            onChange={handleDateTimeChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>
                                )}
                                {BookingData.time && (
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Time</Typography>
                                        <TextField
                                            fullWidth
                                            name="time"
                                            label="Time"
                                            disabled
                                            value={BookingData.time}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                )}

                            </Grid>
                            <Grid container spacing={2} marginTop={'2px'}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Adults</Typography>
                                    <TextField
                                        fullWidth
                                        name="adults"
                                        label="Adults"
                                        type="number"
                                        value={BookingData.adults}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value, 10);
                                            if (value >= 0 || e.target.value === '') { // อนุญาตเฉพาะค่าที่มากกว่าหรือเท่ากับ 0 หรือช่องว่าง
                                                handleChange(e);
                                            }
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}

                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    คน
                                                </InputAdornment>
                                            ),
                                        }}
                                        disabled={!createState}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Children</Typography>
                                    <TextField
                                        fullWidth
                                        name="children"
                                        label="Children"
                                        disabled={!createState}
                                        value={BookingData.children}
                                        onChange={(e) => {
                                            const value = parseInt(e.target.value, 10);
                                            if (value >= 0 || e.target.value === '') { // อนุญาตเฉพาะค่าที่มากกว่าหรือเท่ากับ 0 หรือช่องว่าง
                                                handleChange(e);
                                            }
                                        }}
                                        type="number"
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    คน
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                            </Grid>

                            <Grid container spacing={2} marginTop={'2px'}>
                                {BookingData.boatName && (
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Boat</Typography>
                                        <TextField
                                            fullWidth
                                            name="boatname"
                                            label="Boat"
                                            disabled
                                            value={BookingData.boatName}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </Grid>
                                )}
                                {BookingData.driverName && (
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Driver</Typography>
                                        <TextField
                                            fullWidth
                                            name="driverName"
                                            label="Driver"
                                            value={BookingData.driverName}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            disabled={true}
                                        />
                                    </Grid>
                                )}
                                {BookingData.butlerName && (
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Butler</Typography>
                                        <TextField
                                            fullWidth
                                            name="butlerName"
                                            label="ButlerName"
                                            disabled
                                            value={BookingData.butlerName}
                                            onChange={handleChange}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}

                                        />
                                    </Grid>
                                )}
                            </Grid>
                            {BookingData.noteChange && <Box>
                                <Typography sx={{ margin: '12px' }}>หมายเหตุ การเลื่อน</Typography>
                                <TextField
                                    fullWidth
                                    name="noteChange"
                                    label="หมายเหตุ"
                                    value={BookingData.noteChange}
                                    onChange={handleChange}
                                    multiline
                                    disabled={true}
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>}
                            {BookingData.noteBoat && <Box>
                                <Typography sx={{ margin: '12px' }}>หมายเหตุ การผูกเรือ</Typography>
                                <TextField
                                    fullWidth
                                    name="noteChange"
                                    label="หมายเหตุ"
                                    value={BookingData.noteBoat}
                                    onChange={handleChange}
                                    multiline
                                    disabled={true}
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>}
                        </Card>
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }} >
                            <Typography variant="h5" sx={{ mb: 2 }}>
                                Customer Information
                                <IconButton size="small">
                                    <IoMdInformationCircleOutline />
                                </IconButton>
                            </Typography>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>First Name</Typography>
                                    <TextField
                                        fullWidth
                                        name="first_name"
                                        label="First Name"
                                        required
                                        value={BookingData.first_name}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Last Name</Typography>
                                    <TextField
                                        fullWidth
                                        name="last_name"
                                        label="Last Name"
                                        required
                                        value={BookingData.last_name}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} marginTop={'2px'}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Country</Typography>
                                    <Box marginTop={'16px'}>
                                        <Autocomplete
                                            id="country-select"
                                            options={country}
                                            name="country"
                                            getOptionLabel={(option) => option.label}
                                            renderInput={(params) => <TextField  {...params} label="ประเทศ" />}
                                            value={country.find(p => p.value == BookingData.country) || null}
                                            onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "country")}
                                            fullWidth
                                            disableListWrap
                                            disabled={editMode}
                                            ListboxProps={{
                                                style: {
                                                    maxHeight: '250px',
                                                    overflow: 'auto',
                                                },
                                            }}
                                        />
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container spacing={2} marginTop={'2px'}>
                                <Grid item xs={12}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Address</Typography>
                                    <TextField
                                        fullWidth
                                        name="address"
                                        label="Address"
                                        required
                                        value={BookingData.address}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        multiline
                                        rows={4} // กำหนดจำนวนแถว เช่น 4 แถว
                                    />
                                </Grid>
                            </Grid>
                            {!isThai && (<Grid container spacing={2} marginTop={'2px'}>
                                <Grid item xs={12}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Address Details</Typography>
                                    <TextField
                                        fullWidth
                                        name="address_details"
                                        label="Address"
                                        required
                                        value={BookingData.address_details}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        multiline
                                        rows={4} // กำหนดจำนวนแถว เช่น 4 แถว
                                    />
                                </Grid>
                            </Grid>)
                            }
                            {isThai && (
                                <Grid container spacing={2} marginTop={'2px'}>
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Province</Typography>
                                        <Box marginTop={'16px'}>
                                            <Autocomplete
                                                id="province-select"
                                                options={province}
                                                name="province"
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => <TextField  {...params} label="จังหวัด" />}
                                                value={province.find(p => p.value == BookingData.province) || null}
                                                onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "province")}
                                                fullWidth
                                                disableListWrap
                                                disabled={editMode}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>District</Typography>
                                        <Box marginTop={'16px'}>
                                            <Autocomplete
                                                id="district-select"
                                                options={district}
                                                name="district"
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => <TextField {...params} label="เขต / อำเภอ" />}
                                                value={district.find(p => p.value == BookingData.district) || null}
                                                onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "district")}
                                                fullWidth
                                                disableListWrap
                                                disabled={editMode}
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                            />
                                        </Box>

                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Subdistrict</Typography>
                                        <Box marginTop={'16px'}>
                                            <Autocomplete
                                                id="subdistrict-select"
                                                options={subdistrict}
                                                name="SubDistrict"
                                                getOptionLabel={(option) => option.label}
                                                renderInput={(params) => <TextField {...params} label="แขวน / ตำบล" />}
                                                value={subdistrict.find(p => p.value == BookingData.subdistrict) || null}
                                                onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "subdistrict")}
                                                fullWidth
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                                disabled={!autocompleteState.subDistrict && editMode}
                                            />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Zip_code</Typography>
                                        <Box marginTop={'16px'}>
                                            <Autocomplete
                                                id="zip_code"
                                                options={zip_code}
                                                name="zip_code"
                                                getOptionLabel={(option) => option.zip_code}
                                                renderInput={(params) => <TextField {...params} label="รหัสไปรษณีย์" name='zip_code' />}
                                                value={zip_code.find(p => p.zip_code == BookingData.zip_code) || null}
                                                onChange={(e, newValue) => handleChangeAutocomplate(e, newValue, "zip_code")}
                                                fullWidth
                                                ListboxProps={{
                                                    style: {
                                                        maxHeight: '250px',
                                                        overflow: 'auto',
                                                    },
                                                }}
                                                disabled={!autocompleteState.zip_code && editMode}
                                            />
                                        </Box>

                                    </Grid>
                                </Grid>
                            )}
                            <Grid container spacing={1} marginTop={'2px'}>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Email</Typography>
                                    <TextField
                                        fullWidth
                                        name="email"
                                        label="Email"
                                        required
                                        placeholder="Email"
                                        value={BookingData.email}
                                        onChange={handleChange}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <MdEmail fontSize={'24px'} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <Typography sx={{ marginBottom: 2, fontSize: '18px' }}>Phone</Typography>
                                    <TextField
                                        fullWidth
                                        name="tel"
                                        label="Phone"
                                        required
                                        placeholder="Phone"
                                        value={BookingData.tel}
                                        onChange={(e) => {
                                            const newValue = e.target.value.replace(/[^0-9]/g, ''); // Allows only numbers
                                            handleChange({ target: { name: 'tel', value: newValue } });
                                        }}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        disabled={editMode}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <FaSquarePhone fontSize={'24px'} />
                                                </InputAdornment>
                                            ),
                                            maxLength: 10
                                        }}
                                    />
                                </Grid>
                            </Grid>
                        </Card>
                        <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                            <Box>
                                <Typography sx={{ margin: '12px' }}>วัตถุประสงค์</Typography>
                                <TextField
                                    fullWidth
                                    name="note"
                                    label="วัตถุประสงค์"
                                    value={BookingData.note}
                                    onChange={handleChange}
                                    multiline
                                    disabled={editMode}
                                    minRows={3} // กำหนดจำนวนแถวขั้นต่ำ
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                />
                            </Box>
                        </Card>
                        {createState !== true && (
                            <Card sx={{ padding: 2, margin: 5, boxShadow: 4, borderRadius: 4 }}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="serviceTerms"
                                                checked={BookingData.serviceTerms === 1}
                                                onChange={handleToggleCondition}
                                                disabled={true}
                                            />
                                        }
                                        label="เข้าใจและยอมรับในข้อตกลงและเงื่อนไขการใช้บริการ"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="personalData"
                                                checked={BookingData.personalData === 1}
                                                onChange={handleToggleCondition}
                                                disabled={true}
                                            />
                                        }
                                        label="ยินยอมให้เก็บรวบรวมข้อมูลส่วนบุคลเพื่อการให้บริการ (นโยบายคุ้มครองข้อมูลส่วนบุคคล)"
                                    />
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                name="serviceUpdates"
                                                checked={BookingData.serviceUpdates === 1}
                                                onChange={handleToggleCondition}
                                                disabled={true}
                                            />
                                        }
                                        label="ต้องการรับข่าวสารโปรโมชั่นพิเศษและกิจกรรมทางการตลาด ทั้งนี้ท่านสามารถแจ้งยกเลิกได้ทุกเมื่อ (Optional)"
                                    />
                                </FormGroup>
                            </Card>
                        )}
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 4 }}>
                            <Button variant="outlined" sx={{ margin: 1, width: '200px' }} onClick={() => navigate('/thewonderblueadmin_admin')}>Back</Button>
                            {!editMode && (
                                <Button variant="contained" sx={{ margin: 1, width: '200px' }} onClick={(e) => handleSubmit(BookingData, "แก้ไขข้อมูลลูกค้า")}>Save</Button>
                            )}
                        </Box>
                    </Box>
                </Paper>
            </Box>
            <HistoryModal
                open={openHistory}
                onClose={() => setOpenHistory(false)}
                dataHistory={dataHistory}
            />
            {BoatSelectionModal()}
            {renderTimeSlotModal()}
        </Box>
    );
};

export default TicketForm_View;